<template>
  <div class="drag">
    <div class="drag_bg"></div>
    <div class="drag_text">
      <span>{{ confirmWords }}</span>
    </div>
    <div @mousedown="mousedownFn($event)" @touchstart="mousedownFn($event,true)" class="handler handler_bg"></div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { getCurrentInstance, useI18n } from '../plugins/i18n'

  export default {
    name: 'drag',
    components: {},
    props: {
      confirm: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        beginClientX: 0,
        mouseMoveStata: false,
        maxWidth: 0,
        confirmWords: useI18n().t('components.drag.confirmWords'),
        confirmSuccess: confirm
      }
    },
    created() {
    },
    methods: {
      mousedownFn: function (e, mobileFlag = false) {
        this.mouseMoveStata = true
        this.beginClientX = !mobileFlag ? e.clientX : (e?.touches ? e?.touches[0]?.clientX : 0)
      },
      successFunction() {
        const me = this
        $('.handler').removeClass('handler_bg').addClass('handler_ok_bg')
        this.confirmWords = useI18n().t('components.drag.validSucc')
        $('.drag').css({ 'color': '#fff' })
        getCurrentInstance().global.locale === 'en' && $('.drag_text>span').css({ 'left': '25%' })
        $('.handler').css({ 'left': this.maxWidth })
        $('.drag_bg').css({ 'width': this.maxWidth })
        $('body').unbind('touchmove')
        $('body').unbind('mousemove')
        $('body').unbind('touchend')
        $('body').unbind('mouseup')
        this.confirmSuccess = true
        me.$emit('update:confirm', this.confirmSuccess)
      },
      init() {
        this.maxWidth = parseInt($('.drag').css('width')) - 80

        $('body').on('mousemove', (e) => {
          if (this.mouseMoveStata) {
            var width = e.clientX - this.beginClientX
            if (width > 0 && width <= this.maxWidth) {
              $('.handler').css({ 'left': width })
              $('.drag_bg').css({ 'width': width })
            } else if (width > this.maxWidth) {
              this.successFunction()
            }
          }
        })

        $('body').on('touchmove', (e) => {
          if (this.mouseMoveStata) {
            var width = e.touches[0].clientX - this.beginClientX
            if (width > 0 && width <= this.maxWidth) {
              $('.handler').css({ 'left': width })
              $('.drag_bg').css({ 'width': width })
            } else if (width > this.maxWidth) {
              this.successFunction()
            }
          }
        })

        $('body').on('mouseup', (e) => {
          this.mouseMoveStata = false
          var width = e.clientX - this.beginClientX
          if (width < this.maxWidth) {
            $('.handler').css({ 'left': 0 })
            $('.drag_bg').css({ 'width': 0 })
          }
        })

        $('body').on('touchend', (e) => {
          this.mouseMoveStata = false
          var width = e.changedTouches[0].clientX - this.beginClientX
          if (width < this.maxWidth) {
            $('.handler').css({ 'left': 0 })
            $('.drag_bg').css({ 'width': 0 })
          }
        })
      },
      resetCfg() {
        this.mouseMoveStata = false
        this.confirmSuccess = false
        this.confirmWords = useI18n().t('components.drag.confirmWords')

        $('.drag').css({ 'color': '#000' })
        $('.drag_text>span').css({ 'left': '50%' })
        $('.handler').css({ 'left': 0 })
        $('.drag_bg').css({ 'width': 0 })
        $('.handler').removeClass('handler_ok_bg').addClass('handler_bg')

        this.$emit('update:confirm', this.confirmSuccess)
      },
      reset() {
        this.resetCfg()
        this.init()
      }
    },
    mounted() {
      this.init()
      $(window).resize(() => {
        this.reset()
      })
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .drag {
    position: relative;
    background-color: $--color-grey;
    width: 100%;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: $--border-radius-base;
  }

  .handler {
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
    height: 46px;
    border: 2px solid $--color-grey;
    border-radius: $--border-radius-base 0 0 $--border-radius-base;;
    cursor: move;
  }

  .handler_bg {
    background: $--color-white url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
  }

  .handler_ok_bg {
    border-radius: 0 $--border-radius-base $--border-radius-base 0;
    background: $--color-white url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
  }

  .drag_bg {
    background-color: #7ac23c;
    height: 46px;
    width: 0;
    border-radius: $--border-radius-base 0 0 $--border-radius-base;
  }

  .drag_text {
    position: absolute;
    top: 0;
    width: calc(100% - 80px);
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;

    span {
      position: absolute;
      left: 50%;
    }
  }
</style>
